import React from "react";
import PropTypes from "prop-types";

// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import CheckBox from "@limitless/modern/inputs/checkbox/CheckBox";
import RadioGroup from "@limitless/modern/inputs/radio-group/RadioGroup";
import { useExpertPendingQuestionsContext } from "@limitless/expert";

// Limitless Icons
import CommonFilterPoper from "../filters/CommonFilterPoper";
import { checkBoxStyling } from "../rating-dashboard/Filters";
import { commonCheckboxDetails, RenderAccordion } from "./AvailableFilters";

const STATUS_OPTIONS = [
    { value: "inProgress", label: "In progress" },
    { value: "awaitingPayment", label: "Awaiting payment" }
];

const PendingFilters = ({ clickAwayClose }) => {
    const { filterExists, availableGroups, pendingFilters, updatePendingFilters, clearPendingFilters } =
        useExpertPendingQuestionsContext();

    const { selectedGroups, inProgress, awaitingPayment } = pendingFilters;

    const updateStatus = value => {
        updatePendingFilters({ inProgress: value === "inProgress", awaitingPayment: value === "awaitingPayment" });
    };

    const pendingFiltersArray = React.useMemo(() => {
        return commonCheckboxDetails
            .filter(value => value.key in pendingFilters)
            .map(item => ({
                ...item,
                checked: pendingFilters[item.key],
                onChange: () => updatePendingFilters({ [item.key]: !pendingFilters[item.key] })
            }));
    }, [pendingFilters]);

    return (
        <>
            <CommonFilterPoper
                label="Filter rewards"
                clickAwayClose={clickAwayClose}
                filterExists={filterExists}
                title={"Filter by:"}
                clearFilters={clearPendingFilters}
            >
                <Grid item xs={12}>
                    <RenderAccordion title={"Group"} keyValue={"filter-01"} showDivider>
                        <DropdownMenu
                            ListboxComponent="ul"
                            fullWidth
                            options={availableGroups}
                            value={selectedGroups}
                            onChange={(e, items) => {
                                return updatePendingFilters({
                                    selectedGroups: items
                                });
                            }}
                            multiple
                            disableClearable={false}
                            placeholder="Select group"
                            id="groupDropdownFilter"
                        />
                    </RenderAccordion>
                </Grid>
                <Grid item xs={12}>
                    <RenderAccordion title={"Reward type"} keyValue={"filter-02"} showDivider>
                        <Grid container sx={{ rowGap: 1, marginBottom: 1 }} display="flex" flexDirection="column">
                            {pendingFiltersArray.map(pendingFilter => {
                                return (
                                    <CheckBox
                                        key={pendingFilter.id}
                                        onLabel={pendingFilter.onLabel}
                                        offLabel={pendingFilter.offLabel}
                                        onChange={pendingFilter.onChange}
                                        checked={pendingFilter.checked}
                                        variantStyling={checkBoxStyling}
                                        id={pendingFilter.id}
                                    />
                                );
                            })}
                        </Grid>
                    </RenderAccordion>
                </Grid>
                <Grid item xs={12}>
                    <RenderAccordion title={"Status"} keyValue={"filter-03"} showDivider={false}>
                        <RadioGroup
                            aria-labelledby="radio-buttons-group-label"
                            name="radio-buttons-group"
                            items={STATUS_OPTIONS}
                            sx={{ width: "100%" }}
                            onChange={e => {
                                updateStatus(e.target.value);
                            }}
                            value={inProgress ? "inProgress" : awaitingPayment ? "awaitingPayment" : null}
                            id="statusRadioGroup"
                        />
                    </RenderAccordion>
                </Grid>
            </CommonFilterPoper>
        </>
    );
};

PendingFilters.propTypes = {
    clickAwayClose: PropTypes.bool
};

export default PendingFilters;
